import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import marketingSmsManagementAPI from '../apis/marketingSmsManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class MarketingSmsManagementStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0

  //Status 下拉列表
  @observable statusList = []
  @observable sourceTypeList = []
  @action
  async onGetStatus(params) {
    if(params==='sourceType') {
      this.sourceTypeList = []
    } else {
      this.statusList = []
    }
    try {
      const response = await marketingSmsManagementAPI.getStatus(params)
      const {code, data, messageEn} = response?.data
      runInAction(() => {
        if (code === 0) {
          if(params==='sourceType') {
            this.sourceTypeList = data
          } else {
            this.statusList = data
          }
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  //获取营销分组的 下拉列表
  @observable groupList = []
  @action
  async onGetGroup(params) {
    this.groupList = []
    try {
      const response = await marketingSmsManagementAPI.getGroup(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.groupList = data
        } else {
          alertMessage.error('获取营销分组失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  //获取签名的 下拉列表
  @observable signList = []
  @action
  async onGetSign(params) {
    this.signList = []
    try {
      const response = await marketingSmsManagementAPI.getSign(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.signList = data
        } else {
          alertMessage.error('获取签名失败' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  //获取资源池的 下拉列表
  @observable resourcePoolList = []
  @action
  async onGetResourcePool(params) {
    this.resourcePoolList = []
    try {
      const response = await marketingSmsManagementAPI.getResourcePool(params)
      const {code, data, messageEn} = response?.data
      runInAction(() => {
        if (code === 0) {
          this.resourcePoolList = data?.filter(a=>a?.status===0)
        } else {
          alertMessage.error('获取资源池失败' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  /*SearchResult start*/
  @observable searchItem = {
    'smsType': '1',
    'marketGroupId': '',
    'configName': '',
    'signId': '',
    'smsContent': '',
    'isPowerUser': false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []
  @action
  async onSearchAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await marketingSmsManagementAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }
  /*SearchResult end*/

  /*add */
  @action
  async onAddAction(params, title) {
    this.isFetching = true
    try {
      const response = await marketingSmsManagementAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit*/
  @observable detailsObj = null
  @action
  async onGetAction(params) {
    this.isFetching = true
    try {
      const response = await marketingSmsManagementAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*agree*/
  @action
  async onAgreeAction(params) {
    this.isFetching = true
    try {
      const response = await marketingSmsManagementAPI.agreeAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success(params?.approveResult ==='3' ? '审批成功！' : '拒绝成功！')
          this.onSearchAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error(params?.approveResult ==='3' ? '审批失败！' + response.data.messageEn + '' : '拒绝失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  @action
  async onSyncAction(){
    this.isFetching = true
    try {
      const response = await marketingSmsManagementAPI.syncAction()
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('同步成功！')
          this.onSearchAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('同步失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchAction({
      ...this.searchItem,
      'page': pageNo,
      'size': pageSize,
    })
  }

  @observable templateObj = null
  @action
  onChangeTemplateObj(value) {
    this.templateObj = value
  }
  @observable shortLinkObj = null
  @action
  onChangeShortLinkObj(value) {
    this.shortLinkObj = value
  }

  // phone
  // phone
  // phone
  //生成ID
  @observable generateID = ''
  @action
  async onGenerateIDAction(){
    this.isFetching = true
    try {
      const response = await marketingSmsManagementAPI.generateIDAction()
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.generateID = response.data.data
          // alertMessage.success('Sync Success！')
        } else {
          // alertMessage.error('Sync Failed！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  /*SearchResult start*/
  @observable isFetchingPhone = false
  @observable pageSizePhone = PAGE_SIZE_DEFAULT
  @observable pageNoPhone = 1
  @observable currIndexPhone = 0
  @observable itemCountPhone = 0
  @observable searchItemPhone = {
    'phone': '',
    'isPowerUser' : false,
    'page': this.pageNoPhone,
    'size': this.pageSizePhone,
  }
  @observable phoneList = []
  @observable handPhoneList = []
  @observable filePhoneList = []
  @observable resourcePhoneList = []
  @observable phoneTable = []
  @action
  async onPhoneAction(params) {
    this.isFetchingPhone = true
    this.pageNoPhone = params.page
    this.pageSizePhone = params.size
    this.itemCountPhone = 0
    this.phoneList = []
    try {
      const response = await marketingSmsManagementAPI.phoneAction(params)
      runInAction(() => {
        this.isFetchingPhone = false
        if (response.data.code === 0) {
          this.phoneList = response.data.data?.records || []
          this.itemCountPhone = response.data.data?.total
          this.searchItemPhone = params
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingPhone = false
      })
    }
  }
  @action
  onChangePhonePageNumAction(pageNo, pageSize) {
    if (this.pageNoPhone === pageNo && (!pageSize || this.pageSizePhone === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNoPhone = pageNo
      this.pageSizePhone = pageSize
    })
    this.onPhoneAction({
      ...this.searchItemPhone,
      'page': pageNo,
      'size': pageSize,
    })
  }
  /* 添加号码 */
  @action
  async onAddPhoneAction(params) {
    this.isFetchingPhone = true
    try {
      const response = await marketingSmsManagementAPI.addPhoneAction(params)
      runInAction(() => {
        this.isFetchingPhone = false
        if (response.data.code === 0) {
          alertMessage.success('添加成功！')
        } else {
          alertMessage.error('添加失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingPhone = false
      })
    }
  }
  /* 清空号码 */
  @action
  async onClearPhoneAction(params) {
    this.isFetchingPhone = true
    try {
      const response = await marketingSmsManagementAPI.clearPhoneAction(params)
      runInAction(() => {
        this.isFetchingPhone = false
        if (response.data.code === 0) {
          alertMessage.success('清理成功！')
          this.searchItemPhone = {
            ...this.searchItemPhone,
            ...params,
          }
          this.onPhoneAction({
            ...this.searchItemPhone,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('清理失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingPhone = false
      })
    }
  }
  @action
  onChangePhoneTable(value){
    this.phoneTable = value
  }
  // 手机里 短信内容
  @observable templateParams = []
  @action
  onChangeTemplateParams(value){
    this.templateParams = value
  }

  
  /* 个性短信预览时生产短信内容并分页返回数据 */
  @observable isFetchingPersonalPhone = false
  @observable pageSizePersonalPhone = PAGE_SIZE_DEFAULT
  @observable pageNoPersonalPhone = 1
  @observable currIndexPersonalPhone = 0
  @observable itemCountPersonalPhone = 0
  @observable searchItemPersonalPhone = {
    'sourceType': '',
    'phone': '',
    'taskGroupId': '',
    'isPowerUser' : false,
    'page': 1,
    'size': PAGE_SIZE_DEFAULT
  }
  @observable viewList = []
  @observable phoneCount = 0
  @observable smsCount = 0
  @action
  async onSelfAction(params) {
    this.isFetchingPersonalPhone = true
    this.pageNoPersonalPhone = params.page
    this.pageSizePersonalPhone = params.size
    this.itemCountPersonalPhone = 0
    this.viewList = []
    try {
      const response = await marketingSmsManagementAPI.selfAction(params)
      runInAction(() => {
        this.isFetchingPersonalPhone = false
        if (response.data.code === 0) {
          this.viewList = response.data.data?.data?.records
          this.searchItemPersonalPhone = params
          this.phoneCount = response.data?.data?.phoneCount
          this.smsCount = response.data?.data?.smsCount
          this.itemCountPersonalPhone = response.data.data?.data?.total
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingPersonalPhone = false
      })
    }
  }
  @action
  onChangePersonalPhonePageNumAction(pageNo, pageSize) {
    if (this.pageNoPersonalPhone === pageNo && (!pageSize || this.pageSizePersonalPhone === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNoPersonalPhone = pageNo
      this.pageSizePersonalPhone = pageSize
    })
    this.onSelfAction({
      ...this.searchItemPersonalPhone,
      'page': pageNo,
      'size': pageSize,
    })
  }
  /* 个性短信Excel预览 */
  @observable isFetchingPersonal = false
  @observable pageSizePersonal = PAGE_SIZE_DEFAULT
  @observable pageNoPersonal = 1
  @observable currIndexPersonal = 0
  @observable itemCountPersonal = 0
  @observable searchItemPersonal = {
    "configName": "",
    "marketGroupId": "",
    "sourceType": '',
    "taskGroupId": '',
    'isPowerUser' : false,
    'page': 1,
    'size': PAGE_SIZE_DEFAULT
  }
  @observable excelList = []
  @observable isTestSendFetching = false

  @action
  async onExcelViewAction(params) {
    this.isFetchingPersonal = true
    this.pageNoPersonal = params.page
    this.pageSizePersonal = params.size
    this.itemCountPersonal = 0
    this.excelList = []
    try {
      const response = await marketingSmsManagementAPI.excelViewAction(params)
      runInAction(() => {
        this.isFetchingPhone = false
        if (response.data.code === 0) {
          this.searchItemPersonal = params
          const list = response.data.data?.records
          // 1. 将对象转换为键值对数组
          const entries = list[0]?.title ? Object.entries(JSON.parse(list[0]?.title)) : [];
          // 2. 根据值对键值对数组进行排序
          const sortedEntries = entries.sort((a, b) => a[1] - b[1]);
          // 4. 提取排序后的键
          const arr = sortedEntries?.filter(d=>d[0] !== 'id')?.map(c=>{
            return {
              title: c[0],
              name: c[0] === "手机号码" ? 'phone' : `column${c[1]}Value` || ''
            }
          })
          this.phoneTable = arr
          this.excelList = response.data.data?.records
          this.itemCountPersonal = response.data.data?.total
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingPhone = false
      })
    }
  }
  @action
  onChangeExcelList(val){
    this.excelList = val
    this.pageNoPersonal = 0
    this.pageSizePersonal = PAGE_SIZE_DEFAULT
    this.itemCountPersonal = 0
  }
  @action
  onChangePersonalPageNumAction(pageNo, pageSize) {
    if (this.pageNoPersonal === pageNo && (!pageSize || this.pageSizePersonal === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNoPersonal = pageNo
      this.pageSizePersonal = pageSize
    })
    this.onExcelViewAction({
      ...this.searchItemPersonal,
      'page': pageNo,
      'size': pageSize,
    })
  }
  /*delete*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await marketingSmsManagementAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  
  /* 获取手机号统计结果 */
  @observable handPhoneNum = 0
  @observable validHandPhoneNum = 0
  @observable invalidHandPhoneNum = 0
  @observable filePhoneNum = 0
  @observable validFilePhoneNum = 0
  @observable invalidFilePhoneNum = 0
  @observable resourcePhoneNum = 0
  @observable validResourcePhoneNum = 0
  @observable invalidResourcePhoneNum = 0
  @action
  async onStatisticsAction(params) {
    this.isFetchingPhone = true
    try {
      const response = await marketingSmsManagementAPI.statisticsAction(params)
      runInAction(() => {
        this.isFetchingPhone = false
        if (response.data.code === 0) {
          this.handPhoneNum = response.data.data?.manualNumberTotal || 0
          this.validHandPhoneNum = response.data.data?.manualNumberValid || 0
          this.invalidHandPhoneNum = response.data.data?.manualNumberInvalid || 0
          this.filePhoneNum = response.data.data?.templateImportNumberTotal || 0
          this.validFilePhoneNum = response.data.data?.templateImportNumberValid || 0
          this.invalidFilePhoneNum = response.data.data?.templateImportNumberInvalid || 0
          this.resourcePhoneNum = response.data.data?.resourcePoolImportNumberTotal || 0
          this.validResourcePhoneNum = response.data.data?.resourcePoolImportNumberValid || 0
          this.invalidResourcePhoneNum = response.data.data?.resourcePoolImportNumberInvalid || 0
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingPhone = false
      })
    }
  }
  @action
  onChangeHandPhoneNum(value){
    this.handPhoneNum = value
  }
  @action
  onChangeFilePhoneNum(value){
    this.filePhoneNum = value
  }
  @action
  onChangeResourcePhoneNum(value){
    this.resourcePhoneNum = value
  }
  @action
  onChangeAllNum(value){
    this.allNum = value
  }
  //获取 短信余额
  @observable smsBalanceSum = 0
  @action
  async onSmsBalance(params) {
    this.smsBalanceSum = []
    try {
      const response = await marketingSmsManagementAPI.smsBalance(params)
      runInAction(() => {
        if (response.data.code === 0) {
          this.smsBalanceSum = response.data.data || 0
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  @action
  onChangeSmsBalanceSum(value) {
    this.smsBalanceSum = value
  }

  //重新发送
  @action
  async onReSendAction(params) {
    this.isFetching = true
    try {
      const response = await marketingSmsManagementAPI.reSendAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('重新发送成功！')
          this.onSearchAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('重新发送失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  //展会届次列表
  @observable expoList = []
  @action
  async onExpoAction(params) {
    this.expoList = []
    try {
      const response = await marketingSmsManagementAPI.expoAction(params)
      runInAction(() => {
        if (response.data.code === 0) {
          this.expoList = response.data.data
        } else {
          alertMessage.error('重新发送失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }


  // 短信测试接口
  @action
  async onSendTestPhone(params) {
    this.isTestSendFetching = true;
    try {
      const response = await marketingSmsManagementAPI.sendTestPhone(params)
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        this.isTestSendFetching = false;
        if (code === 0) {
          alertMessage.success('发送成功')
        } else {
          alertMessage.error('发送失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isTestSendFetching = false;
      })
    }
  }
}
